module.exports = "https://portperrypedals.ca/_res/img/rest-stop.684914e.jpg";